import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { authReducer } from 'data_system/token_auth/reducer';
import { initialPropsReducer } from './initialPropsReducer';
import { experiencesReducer } from './experiencesReducer';

export const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    initialProps: initialPropsReducer,
    auth: authReducer,
    experiences: experiencesReducer,
  });
